const prodConfig = {
  api: {
    protocol: 'https://',
    host: 'admin.igreen.org',
    port: '',
    prefix: '/api',
    postfix: '?v=1.0'
  }
};

export default prodConfig;
